// extracted by extract-css-chunks-webpack-plugin
module.exports = {"seller-page-past-section":"seller-page-past-section___3k_6N","header-text-large":"header-text-large___zGk4W","pagination":"pagination___rqhWC","grid":"grid___1HxYp"};